import React from 'react';
import { withTranslation } from 'react-i18next';
import { history } from '../../routes';
import config from '../../config';
import LayoutSmall from '../../components/layout/LayoutSmall';
import { isEmptyObject } from '../../libraries/utils';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import prescriptionsActions from '../../context/prescriptions/actions';
import { notify } from '../../libraries/notifications';

class VerifyPrescription extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      prescription: null,
    }
  }

  componentDidMount() {
    this.getPrescription()
    const state = this.props.location.state;
    this.setState({ route: !isEmptyObject(state) ? (state.root_id ? config.ROUTES.CHAT.replace(':root_id', state.root_id) : state.from) : config.ROUTES.PRESCRIPTION.LIST });
    console.log('ROUTE??', { route: !isEmptyObject(state) ? (state.root_id ? config.ROUTES.CHAT.replace(':root_id', state.root_id) : state.from) : config.ROUTES.PRESCRIPTION.LIST })
  }

  getPrescription = async () => {
    const params = this.props.match.params;
    if (params.id) {
      await this.props.onGet(params.id)
      const prescription = this.props.prescription
      if (prescription.error) {
        notify(this.t(prescription.error.message));
      } else {
        this.setState({ prescription: prescription.item });
      }
    }
  }

  componentWillUnmount() {
    this.props.onClearCurrent();
  }

  onExit = async () => {
    const back = (this.props.location && this.props.location.state && this.props.location.state.from) ? this.props.location.state.from : config.ROUTES.HOME;
    history.push(back);
  }
  render() {
    const { prescription } = this.state;
    const profverified = prescription?.json_data?.professional?.verified === "verified"
    const patientverified = prescription?.json_data?.patient?.verified === "verified"
    const licenseverified = prescription?.json_data?.professional?.md_verified === "verified"
    /* 
      Realizar la verificacion si es a nivel prescripcion o se verifica en el momento el profesional y el paciente
      md_
    */
    return (
      <LayoutSmall
          header={{
              className: "bg-primary",
              title: this.t("Verification"),
              left: { icon: 'home', action: this.onExit }
          }}
          main={{
              className: "light-primary-bg text-gray-700",
          }}
          loading={this.props.prescription.loading}
      >
          <ToastContainer />
          <div className="section-card mt-5">
              {prescription ?
                  <>
                      <h1 className='text-center'>Prescripción</h1>
                      <h2 className='mt-10'>Número:</h2>
                      <small className="mb-1 text-gray-500 px-2">{prescription.json_data.prescription_num.toString().padStart(8, '0')}</small>
                      <h2 className='mt-10'>Fecha:</h2>
                      <small className="mb-1 text-gray-500 px-2">{prescription.date.slice(0,10)}</small>
                      <h2 className='mt-10'>Profesional:</h2>
                      <small className="mb-1 text-gray-500 px-2">{profverified  ? 'Verificado' : 'No Verificado'}</small>
                      <h2 className='mt-10'>Matrícula:</h2>
                      <small className="mb-1 text-gray-500 px-2">{licenseverified ? 'Verificada' : 'No Verificada'}</small>
                      <h2 className='mt-10'>Paciente:</h2>
                      <small className="mb-1 text-gray-500 px-2">{patientverified ? 'Verificado' : 'No Verificado'}</small>
                  </>
                  :
                  <> Prescripcion no es valida </>
              }
          </div>
      </LayoutSmall>
    );
  }
}
const mapStateToProps = state => {
    return {
        auth: state.users.auth,
        prescription: state.prescriptions.current,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGet: (id) => dispatch(prescriptionsActions.get(id)),
        onClearCurrent: (id) => dispatch(prescriptionsActions.clearCurrent()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps,)(withTranslation()(VerifyPrescription));
